// extracted by mini-css-extract-plugin
export default {"loaderThreeDots":"loader_loaderThreeDots__gh6od"};